<script lang="ts" setup>
const title = '会社紹介'

const text = `
株式会社X＆R GLOBALは、ITONIFF社（伊藤忠商事の中国事業会社とSNIFF社との合弁会社）の100%子会社の日本法人として2023年11月に設立されました。
<br/>
<br/>
設立以来、当社は一部の事業者様に向けてB2B越境調達サービスであるCKB Xの事業推進を中心に進めて参りました。
<br/>
<br/>
2025年3月にローンチする、新事業（THE CKB Choice）においては、伊藤忠商事が持つグローバルネットワークと、SNIFF社の越境ECリソースとAIを組み合わせ、より多くの事業者様に、時代にフィットした仕入体験をしていただきたいと考えています。
`
</script>

<template>
  <div id="brief">
    <ADevice>
      <template #h5>
        <div class=" w-[100%] mb-6">
          <img src="https://static-jp.theckb.com/static-asset/xr/ito_1.png" alt="">
        </div>
        <MContainer class=" pb-12">
          <MCol class=" gap-6">
            <MText size="h1" class="font-black" placement="left">
              {{ title }}
            </MText>
            <MText size="lg" placement="left">
              <div v-html="text" class="text-justify font-normal text-black/85"></div>
            </MText>
            <ALink class=" flex justify-end items-end gap-[5px]" to="/">
              <MText size="sm" class=" font-[900] leading-[8px] text-black">ABOUT US</MText>
              <img class=" h-[26px]" src="/assets/image/icon/arrow-up.png" alt="">
            </ALink>
          </MCol>
        </MContainer>
      </template>
      <template #pc>
        <AContainer class=" px-[160px] py-[72px]">
          <div class=" flex gap-[48px]">
            <img class=" h-[480px]" src="https://static-jp.theckb.com/static-asset/xr/ito_1.png" alt="">
            <MCol class=" gap-[24px]">
              <AText size="h1" placement="left">{{ title }}</AText>
              <MText size="lg" placement="left" class="text-justify flex-1" v-html="text"></MText>
              <div class=" flex justify-end">
                <ALink class=" flex justify-end items-end gap-[5px]" to="/">
                  <MText class=" font-[900] leading-[16px]">ABOUT US</MText>
                  <img class=" h-[50px]" src="/assets/image/icon/arrow-up.png" alt="">
                </ALink>
              </div>
            </MCol>
          </div>
        </AContainer>
      </template>
    </ADevice>
  </div>
</template>

<style lang="scss" scoped></style>
